import { Role } from '../interfaces/role';

export const UserRoles = {
  CUSTOMER_SERVICE: 'customer_service',
  ADMIN: 'admin',
  SYSTEM_ADMIN: 'system_admin',
  ACCOUNT_MANAGER: 'account_manager',
  MARKETING: 'marketing',
  FINANCE: 'finance',
  RECRUITER: 'recruiter',
  CUSTOMER_SERVICE_SUPERVISOR: 'customer_service_supervisor',
  PROCUREMENT: 'procurement',
  SALES: 'sales',
} as const;

export const payrollAllowedRoles: Role[] = [
  UserRoles.CUSTOMER_SERVICE,
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.MARKETING,
  UserRoles.SALES,
];

export const viewJobPaymentProhibitedRoles: Role[] = [UserRoles.CUSTOMER_SERVICE, UserRoles.MARKETING, UserRoles.SALES];

const clientsActionsAccessRoles: Role[] = [
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.FINANCE,
  UserRoles.MARKETING,
  UserRoles.SALES,
  UserRoles.SYSTEM_ADMIN,
  UserRoles.CUSTOMER_SERVICE_SUPERVISOR,
];

const unitSubunitEditRoles: Role[] = [
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.FINANCE,
  UserRoles.MARKETING,
  UserRoles.SALES,
  UserRoles.SYSTEM_ADMIN,
  UserRoles.CUSTOMER_SERVICE_SUPERVISOR,
  UserRoles.ADMIN,
];

export const serviceRoles: Role[] = [
  UserRoles.CUSTOMER_SERVICE,
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.MARKETING,
  UserRoles.SALES,
  UserRoles.RECRUITER,
  UserRoles.CUSTOMER_SERVICE_SUPERVISOR,
];

export const applicantsActionsAccessRoles: Role[] = [
  UserRoles.ADMIN,
  UserRoles.SYSTEM_ADMIN,
  UserRoles.FINANCE,
  UserRoles.RECRUITER,
];

const addTalentToMyTeamRoles: Role[] = [
  UserRoles.SYSTEM_ADMIN,
  UserRoles.FINANCE,
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.SALES,
  UserRoles.CUSTOMER_SERVICE_SUPERVISOR,
];

export const timesheetsRoles: Role[] = [
  UserRoles.SYSTEM_ADMIN,
  UserRoles.ACCOUNT_MANAGER,
  UserRoles.CUSTOMER_SERVICE,
  UserRoles.CUSTOMER_SERVICE_SUPERVISOR,
  UserRoles.FINANCE,
  UserRoles.ADMIN,
];

export const isSystemAdminOrCustomerServiceSupervisorOrFinance = (role: Role) =>
  role &&
  ([UserRoles.SYSTEM_ADMIN, UserRoles.CUSTOMER_SERVICE_SUPERVISOR, UserRoles.FINANCE] as Role[]).includes(
    role.toLowerCase() as Role,
  );

export const isSystemAdmin = (role: Role) => UserRoles.SYSTEM_ADMIN === role.toLowerCase();

export const isProcurement = (role: Role) => UserRoles.PROCUREMENT === role.toLowerCase();

export const isAdmin = (role: Role) => UserRoles.ADMIN === role.toLowerCase();

export const isSystemAdminRoleOrHR = (role: Role) =>
  role && ([UserRoles.SYSTEM_ADMIN, UserRoles.ADMIN] as Role[]).includes(role.toLowerCase() as Role);

export const isFinanceOrSystemAdminRole = (role: Role) =>
  role && ([UserRoles.SYSTEM_ADMIN, UserRoles.FINANCE] as Role[]).includes(role.toLowerCase() as Role);

export const isFinanceOrAdminOrSystemAdminRole = (role: Role) =>
  ([UserRoles.ADMIN, UserRoles.SYSTEM_ADMIN, UserRoles.FINANCE] as Role[]).includes(role.toLowerCase() as Role);

export const isCustomerServiceRole = (role: Role) =>
  ([UserRoles.CUSTOMER_SERVICE, UserRoles.CUSTOMER_SERVICE_SUPERVISOR] as Role[]).includes(role.toLowerCase() as Role);

export const hasClientAccess = (role: Role) => role && clientsActionsAccessRoles.includes(role.toLowerCase() as Role);

export const hasUnitSubunitEditAccess = (role: Role) =>
  role && unitSubunitEditRoles.includes(role.toLowerCase() as Role);

export const hasApplicantsActionsAccess = (role: Role) =>
  role && applicantsActionsAccessRoles.includes(role.toLowerCase() as Role);

export const hasAddTalentToMyTeamAccess = (role: Role) =>
  role && addTalentToMyTeamRoles.includes(role.toLowerCase() as Role);
